import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../core/services/Singleton";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { BasicTable, MASK_DECIMAL, MASK_MONEY } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { _ProjectProductCrud } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { ProjectSelectEditor } from "../../../RemoteAbstractAction/editors/ProjectSelectEditor";
import { SelectorUmeasurement } from "../../../bpm/config/Componentes/SelectorUmeasurement";
import { InputDate } from "../../../theme/Input/InputDate";
import { AdquisitionArticleConstantsEditor } from "./AdquisitionArticleConstantsEditor";
import { GoodTypesConstantsEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/GoodTypesConstants.editor";
import { SelectFixedAsset } from "../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { AdquisitionProjectLinesEditor } from "../AdquisitionProjectLinesEditor";




export const ProjectProductCrud = () => {

    const project = useDataBean(_ProjectProductCrud);
    const [form, setForm] = useState<any>({
        IDProject: null,
        ProjectName: null,
    })
    const [formato, setFormato] = useState<any>([]);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modalzip, setModalzip] = useState<any>({ name: 'Información', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalhistorial, setModalhistorial] = useState<any>({ name: 'Historial', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcerti, setModalcerti] = useState<any>({ name: 'Certificaciones', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalref, setModalref] = useState<any>({ name: 'Referencias', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [Year, setYear] = useState<any>(null)
    const paginador = usePaginator();


    useEffect(() => {
        getLista();
    }, [paginador.page])

    useEffect(() => {
        if (form.IDProject) {
            project.setBean((prev: any) => ({
                ...prev,
                IDProject: form.IDProject,
            }));
        }
    }, [form.IDProject]);

    const getLista = () => {

        project.instance.getProjectProductCatalog(form.IDProject, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    let x = resp.List;
                    x.forEach((item: any) => {
                        item.DataBeanProperties.UnitCode = (item.DataBeanProperties.MeasurementUnitCode ?? "") + "-" + (item.DataBeanProperties.MeasurementUnitName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }



    const create = () => {
        project.setBean({
            IDEmployee: _single.getAccountID(),
            IDProject: form.IDProject,

        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        project.instance.updateProjectProduct(project.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const deleteItem = () => {
        //console.log(Project.bean);
        project.instance.deleteProjectProduct(project.bean.IDProjectProduct).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const exportProjectProduct = () => {
        if (!form.IDProject) {
            toast.warning("Debe seleccionar un Proyecto.");
            return;
        }

        project.instance.exportProjectProduct(form.IDProject).then(
            (resp: any) => {
                toast.success('Exportado');
                setFormato(resp[0]);
                setModalzip({ ...modalzip, "view": true });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProjectProduct', visible: true },
        { title: 'ID Proyecto', property: 'IDProject', visible: true },
        { title: 'Código de Proyecto', property: 'ProjectCode', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Unidad de Medida', property: 'UnitCode', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Costo Unitario', property: 'UnitaryCost', visible: true, mask: MASK_MONEY },
        { title: 'Valor Cliente', property: 'ProjectCost', visible: true, mask: MASK_MONEY },
        { title: 'Costo Total Proyecto', property: 'TotalCost', visible: true },
        { title: 'Costo Proyecto', property: 'TotalProjectValue', visible: true },
        { title: 'Porcentaje Utilidad', property: 'UtilityPercent', visible: true, mask: MASK_DECIMAL },
        { title: 'Fecha Inicio Plazo Entrega', property: 'InitDate', visible: true },
        { title: 'Fecha Fin Plazo Entrega', property: 'UptoDate', visible: true },
        { title: 'Tipo de Artículo', property: 'AdquisitionArticleTypeName', visible: true },
        { title: 'Tipo de Bien', property: 'GoodTypeName', visible: true },
        { title: 'Tipo Recurso', property: 'ResourceName', visible: true },
        { title: 'ID PAA', property: 'IDAdquisitionItem', visible: true },
        { title: 'Descripción PAA', property: 'AdquisitionItemDescription', visible: true },
        { title: 'Creado/Actualizado Por', property: 'EmployeeName', visible: true },
        { title: 'Fecha Creación', property: 'Since', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            // { titulo: 'Exportar Lista de Recursos', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { exportProjectProduct() } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Definición de Precios y Costos de Proyectos">
            <div className="row">
                <div className="col-md-6">
                    <label>Proyecto</label>
                    <ProjectSelectEditor render={form.ProjectName} idSelector={form.IDProject} onChange={(e) => { setForm({ ...form, "IDProject": e.IDProject, "ProjectName": e.Name }) }} label=" " returnType="Object" />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>

                {form.IDProject && <>
                    <div className="col-md-4">
                        <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={exportProjectProduct}>
                            Exportar Productos de Proyecto
                        </BasicButton>
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head} rowSet={project.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                    </div>
                </>}
                <div className="col-md-12">

                    <Modal modal={modalzip} updateModal={setModalzip}>
                        <div className="row">
                            {formato?.DataBeanProperties?.URLLink && (
                                // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                <div className="row">
                                    <div className="col-md-6 mt-3">
                                        <a href={formato.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                            <strong> 📄 {formato.DataBeanProperties.Filename}</strong>
                                        </a>
                                    </div>
                                </div>

                            )}



                        </div>
                    </Modal>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Proyecto</label>
                                    <ProjectSelectEditor
                                        render={form.ProjectName}
                                        idSelector={form.IDProject}
                                        onChange={(e) => {
                                            project.setBean({ ...project.bean, "IDProject": e.IDProject, "ProjectName": e.Name, })
                                        }}
                                        label=" "
                                        returnType="Object"
                                    />
                                </div>

                                <div className="col-md-6">
                                    <AdquisitionProjectLinesEditor render={project.bean.ID} idProject={project.bean.IDProject} idSelector={project.bean.IDAdquisitionItem} onChange={(e) => { project.setBean({ ...project.bean, "IDAdquisitionItem": e.IDAdquisitionItem, "ID": e.IDAdquisitionItem, }) }} returnType="Object" />

                                </div>
                                <div className="col-md-6">
                                    <label>Nombre</label>
                                    <input type='text' name="Name" className="form-control" value={project.bean.Name} onChange={project.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <SelectorUmeasurement idSelector={project.bean.IDMeasurementUnit} onChange={(e) => { project.setBean({ ...project.bean, "IDMeasurementUnit": e }) }} titulo="Unidad de Medida" />
                                </div>
                                <div className="col-md-6">
                                    <label>Cantidad</label>
                                    <input type='text' name="Quantity" className="form-control" value={project.bean.Quantity} onChange={(e) => { project.setBean({ ...project.bean, "Quantity": parseInt(e.target.value) }) }} />
                                </div>
                                <div className="col-md-12">
                                    <InputMoney _label="Costo Unitario" _value={project.bean.UnitaryCost} onChange={(e) => { project.setBean({ ...project.bean, "UnitaryCost": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <InputMoney _label="Valor Cliente" _value={project.bean.ProjectCost} onChange={(e) => { project.setBean({ ...project.bean, "ProjectCost": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate name="InitDate" label="Fecha Inicio Plazo Entrega" value={project.bean.InitDate} setDate={(e: any) => { project.setBean({ ...project.bean, "InitDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate name="UptoDate" label="Fecha Fin Plazo Entrega" value={project.bean.UptoDate} setDate={(e: any) => { project.setBean({ ...project.bean, "UptoDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <AdquisitionArticleConstantsEditor idSelector={project.bean.AdquisitionArticleType} onChange={(e) => { project.setBean({ ...project.bean, "AdquisitionArticleType": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <GoodTypesConstantsEditor label='Tipo de Bien' idSelector={project.bean.GoodType} onChange={(e) => { project.setBean({ ...project.bean, "GoodType": e }) }} />
                                </div>
                                {project.bean.GoodType == 5 && (
                                    <div className="col-md-12">
                                        <label>Activo Fijo</label>
                                        <SelectFixedAsset render={project.bean.FixedAssetName} idSelector={project.bean.IDFixedAsset} onChange={(e) => { project.setBean({ ...project.bean, "IDFixedAsset": e.IDFixedAsset, "FixedAssetName": e.Description }) }} label=" " returnType="Object" />
                                    </div>
                                )}
                                {project.bean.GoodType == 6 && (
                                    <div className="col-md-12">
                                        <SelectProductEditor value={project.bean.IDProduct} onChange={(e) => { project.setBean({ ...project.bean, "IDProduct": e.IDProduct, "ProductName": e.Description }) }} label="Producto Inventario" />
                                    </div>
                                )}
                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={project.bean.Description} onChange={project.handleChange} />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}